import React from "react";
import DivisionCardCmp from "../../components/cards/divisionCardCmp";
import RegisterNewRequest from "./register";
import { DivisioncaredContentComponent } from "../../components/cards/divisionCardContentComponent";
import { HandleNext } from "../../models/sharedFunctions";
import { useQueryClient } from "react-query";
import {
  CUSTOMER_INFO,
  LOAN_ID,
  LOAN_TEMPLATE_INFOS,
} from "../../config/cacheKey";
import { LoanTemplateInfo } from "../../models/loan.model";

const content = [{ title: "سقف قابل اعطا:", data: "54654613 ریال" }];

function _DivisionCardContentCmp() {
  return <DivisioncaredContentComponent />;
}

export default function CompleteInfo({ handleNext }: HandleNext) {
  const queryClient = useQueryClient();
  const loanInfo = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS
  );
  const loan_id = queryClient.getQueryData(LOAN_ID);
  const listloan = loanInfo
    ?.filter((item: any) => item.id == loan_id)
    .map((item: any, index: number, array: any) => {
      return {
        title: item.title,
        cardImage: item.cardImage,
        id: item.id,
        maxAmount: item.maxAmount,
        profitPercentage: item.profitPercentage,
        expirationDate_Persian: item.expirationDate_Persian,
        financialSupplierTitle: item.financialSupplierTitle,
        isBySupplierCredit: item.isBySupplierCredit,
        supplierCredit: item.supplierCredit,
      };
    });

  const customerInfos = queryClient.getQueryData(CUSTOMER_INFO);
  const child = <_DivisionCardContentCmp />;
  return (
    <div>
      <DivisionCardCmp
        title="طرح رز"
        value={listloan}
        titleCard="مشخصات طرح انتخاب شده:"
      />
      <RegisterNewRequest
        handleNext={handleNext}
      // handelDisplayFacility={true}
      />
    </div>
  );
}
